import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox } from 'react-bootstrap';
import styles from './TriStateCheckbox.module.css';

// A checkbox that also shows a "partially selected" state, for a group of options.
const TriStateCheckbox = ({
  checked,
  indeterminate,
  onChange,
  label,
  children,
  className,
}) => (
  <Checkbox
    checked={checked}
    onChange={onChange}
    inputRef={(input) => {
      if (input) input.indeterminate = indeterminate;
    }}
    className={`${indeterminate ? styles.indeterminate : ''} ${className || ''}`}
  >
    <span className="checkmark"></span>
    <span>{label}</span>
    {children}
  </Checkbox>
);

TriStateCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

TriStateCheckbox.defaultProps = {
  indeterminate: false,
  children: null,
  className: '',
};

export default TriStateCheckbox;
